import { create } from 'zustand';
import { APP_SETTINGS_LS_KEY } from '../constant/key';

interface ThemeState {
  isDark: boolean;
  setDark: (isDark: boolean) => void;
  initializeTheme: () => void;
}

const getStoredTheme = (): boolean => {
  try {
    const settings = localStorage.getItem(APP_SETTINGS_LS_KEY);
    if (settings) {
      const parsed = JSON.parse(settings);
      return parsed.isDark ?? false;
    }
  } catch {
    // ignore parse errors
  }
  return false;
};

const persistTheme = (isDark: boolean) => {
  try {
    const settings = localStorage.getItem(APP_SETTINGS_LS_KEY);
    const parsed = settings ? JSON.parse(settings) : {};
    parsed.isDark = isDark;
    localStorage.setItem(APP_SETTINGS_LS_KEY, JSON.stringify(parsed));
  } catch {
    // ignore errors
  }
};

const applyThemeClass = (isDark: boolean) => {
  const root = document.documentElement;
  if (isDark) {
    root.classList.add('dark-theme');
  } else {
    root.classList.remove('dark-theme');
  }
};

export const themeStore = create<ThemeState>((set) => ({
  isDark: false,

  setDark: (isDark: boolean) => {
    persistTheme(isDark);
    applyThemeClass(isDark);
    set({ isDark });
  },

  initializeTheme: () => {
    const isDark = getStoredTheme();
    applyThemeClass(isDark);
    set({ isDark });
  },
}));
